// extracted by mini-css-extract-plugin
module.exports = {"root":"Table-root-12KhE","fullWidth":"Table-fullWidth-ejnn7"};